const paymentFormDetails = {
  address: {
    options: [
      // {
      //   value: '1249 Tongass Avenue, Suite B, KETCHIKAN, Alaska, 99901',
      //   label: '1249 Tongass Avenue, Suite B, KETCHIKAN, Alaska, 99901',
      // },
      {
        value: 'NEW',
        label: 'New Address',
      },
    ],
  },
  month: {
    options: [
      {
        value: '01',
        label: '01',
      },
      {
        value: '02',
        label: '02',
      },
      {
        value: '03',
        label: '03',
      },
      {
        value: '04',
        label: '04',
      },
      {
        value: '05',
        label: '05',
      },
      {
        value: '06',
        label: '06',
      },
      {
        value: '07',
        label: '07',
      },
      {
        value: '08',
        label: '08',
      },
      {
        value: '09',
        label: '09',
      },
      {
        value: '10',
        label: '10',
      },
      {
        value: '11',
        label: '11',
      },
      {
        value: '12',
        label: '12',
      },
    ],
  },
  country: {
    options: [
      // {
      //   label: 'US',
      //   value: 'US',
      // },
      // {
      //   label: 'CANADA',
      //   value: 'CANADA',
      // },
    ],
  },
  state: {
    options: [
      // {
      //   label: 'Alabama',
      //   value: 'AL',
      // },
      // {
      //   label: 'Alaska',
      //   value: 'AK',
      // },
      // {
      //   label: 'Arizona',
      //   value: 'AZ',
      // },
      // {
      //   label: 'Arkansas',
      //   value: 'AR',
      // },
      // {
      //   label: 'California',
      //   value: 'CA',
      // },
      // {
      //   label: 'Colorado',
      //   value: 'CO',
      // },
      // {
      //   label: 'Connecticut',
      //   value: 'CT',
      // },
      // {
      //   label: 'Delaware',
      //   value: 'DE',
      // },
      // {
      //   label: 'District of Columbia',
      //   value: 'DC',
      // },
      // {
      //   label: 'Florida',
      //   value: 'FL',
      // },
      // {
      //   label: 'Georgia',
      //   value: 'GA',
      // },
      // {
      //   label: 'Hawaii',
      //   value: 'HI',
      // },
      // {
      //   label: 'Idaho',
      //   value: 'ID',
      // },
      // {
      //   label: 'Illinois',
      //   value: 'IL',
      // },
      // {
      //   label: 'Indiana',
      //   value: 'IN',
      // },
      // {
      //   label: 'Iowa',
      //   value: 'IA',
      // },
      // {
      //   label: 'Kansa',
      //   value: 'KS',
      // },
      // {
      //   label: 'Kentucky',
      //   value: 'KY',
      // },
      // {
      //   label: 'Lousiana',
      //   value: 'LA',
      // },
      // {
      //   label: 'Maine',
      //   value: 'ME',
      // },
      // {
      //   label: 'Maryland',
      //   value: 'MD',
      // },
      // {
      //   label: 'Massachusetts',
      //   value: 'MA',
      // },
      // {
      //   label: 'Michigan',
      //   value: 'MI',
      // },
      // {
      //   label: 'Minnesota',
      //   value: 'MN',
      // },
      // {
      //   label: 'Mississippi',
      //   value: 'MS',
      // },
      // {
      //   label: 'Missouri',
      //   value: 'MO',
      // },
      // {
      //   label: 'Montana',
      //   value: 'MT',
      // },
      // {
      //   label: 'Nebraska',
      //   value: 'NE',
      // },
      // {
      //   label: 'Nevada',
      //   value: 'NV',
      // },
      // {
      //   label: 'New Hampshire',
      //   value: 'NH',
      // },
      // {
      //   label: 'New Jersey',
      //   value: 'NJ',
      // },
      // {
      //   label: 'New Mexico',
      //   value: 'NM',
      // },
      // {
      //   label: 'New York',
      //   value: 'NY',
      // },
      // {
      //   label: 'North Carolina',
      //   value: 'NC',
      // },
      // {
      //   label: 'North Dakota',
      //   value: 'ND',
      // },
      // {
      //   label: 'Ohio',
      //   value: 'OH',
      // },
      // {
      //   label: 'Oklahoma',
      //   value: 'OK',
      // },
      // {
      //   label: 'Oregon',
      //   value: 'OR',
      // },
      // {
      //   label: 'Pennsylvania',
      //   value: 'PA',
      // },
      // {
      //   label: 'Rhode Island',
      //   value: 'RI',
      // },
      // {
      //   label: 'South Carolina',
      //   value: 'SC',
      // },
      // {
      //   label: 'South Dakota',
      //   value: 'SD',
      // },
      // {
      //   label: 'Tennessee',
      //   value: 'TN',
      // },
      // {
      //   label: 'Texas',
      //   value: 'TX',
      // },
      // {
      //   label: 'Utah',
      //   value: 'UT',
      // },
      // {
      //   label: 'Vermont',
      //   value: 'VT',
      // },
      // {
      //   label: 'Virginia',
      //   value: 'VA',
      // },
      // {
      //   label: 'Washington',
      //   value: 'WA',
      // },
      // {
      //   label: 'West Virginia',
      //   value: 'WV',
      // },
      // {
      //   label: 'Wisconsin',
      //   value: 'WI',
      // },
      // {
      //   label: 'Wyoming',
      //   value: 'WY',
      // },
    ],
  },
  year: {
    options: [],
  },
};
export default paymentFormDetails;



// WEBPACK FOOTER //
// ./src/components/common/vx-add-payment-form/payment-form-details.js